export const ID = '55d01a22-b641-4da7-85fd-7b6351da79c0';

export const NAME = 'Facility Image';
